import axios from "axios";
import Swal from "sweetalert2";

export async function apiReq(
    endPoint,
    data,
    method,
    headers,
    requestOptions = {}
) {
    return new Promise(async (res, rej) => {
        console.log("apiReq", endPoint, data, method, headers, requestOptions);
        if (method === "get" || method === "delete") {
            data = {
                ...requestOptions,
                ...data,
                headers,
            };
        }
        axios[method](endPoint, data, {headers})
            .then((result) => {
                const { data } = result;

                if (!data.success) {
                    // Swal.fire({
                    //   position: "center",
                    //   icon: "error",
                    //   title: data.message,
                    //   showConfirmButton: false,
                    //   timer: 1500,
                    // });

                    // console.log(data.message);
                    return rej(data);
                }

                return res(data);
            })
            .catch((error) => {
                // console.log(error)
                // console.log(error && error.response, "the error respne")
                if (error && error.response && error.response.status === 401) {
                }
                if (error && error.response && error.response.data) {
                    if (!error.response.data.message) {
                        return rej({
                            ...error.response.data,
                            msg: error.response.data.message || "Network Error",
                        });
                    }
                    return rej(error.response.data);
                } else {
                    return rej({ message: "Network Error", msg: "Network Error" });
                }
            });
    });
}

export function apiGet(endPoint, data, method, headers, requestOptions) {
    return apiReq(endPoint, data, method, headers, requestOptions);
}
